import React from 'react';
import styled, { keyframes } from 'styled-components';
import { pauseAnimationsOnMobile, respectReducedMotion } from '../styles/performance';

const twinkle = keyframes`
  0% { background-position: 0 0, 0 0, 0 0, 0 0; }
  100% { background-position: 200px 200px, 300px 300px, 400px 400px, 600px 600px; }
`;

const CosmosBackground = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background: radial-gradient(ellipse at bottom, #0a0c12 0%, #010103 100%);
`;

const Stars = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background-image:
    radial-gradient(1px 1px at 25% 25%, rgba(255,255,255,0.9), rgba(0,0,0,0)),
    radial-gradient(1px 1px at 50% 50%, rgba(255,255,255,0.8), rgba(0,0,0,0)),
    radial-gradient(2px 2px at 75% 75%, rgba(255,255,255,0.7), rgba(0,0,0,0)),
    radial-gradient(2px 2px at 100% 100%, rgba(255,255,255,0.6), rgba(0,0,0,0));
  background-size: 200px 200px, 300px 300px, 400px 400px, 600px 600px;
  background-repeat: repeat;
  opacity: 0.45;
  animation: ${twinkle} 10s linear infinite;
  ${pauseAnimationsOnMobile}
  ${respectReducedMotion}
`;

const SectionBackdrop = () => (
  <>
    <CosmosBackground />
    <Stars />
  </>
);

export default SectionBackdrop;
